
import AxiosClient from "../../../services/axios.services";

class EmployeeEvaluableMonitorServices {
  getEvaluableEmployeeMonitor = (params) =>
    AxiosClient.get("api/app/capacitacion_monitor_evaluacion_resultado/", {
      headers: { "Content-Type": "application/json" },
      params: params,
   });
}

export default new EmployeeEvaluableMonitorServices();